
export function envPlugin() {
    return {
        $env: window?.env
    }
}